export const enProduct = {
  "product.activeRevenuePolicies": "Active revenue policies",
  "product.assetCount": "{{count}} assets",
  "product.blockNumber": "Block {{block}}",
  "product.bondingCurve": "Bonding curve",
  "product.boundReferrerInviteCode": "Bound referrer code",
  "product.cannotBindOwnInviteCode":
    "You cannot bind your own invite code. Enter another user's code.",
  "product.claim": "Claim",
  "product.confirming": "Confirming…",
  "product.creatorLaunches": "Creator launches",
  "product.creatorShareValue": "Creator share {{percent}}%",
  "product.noCreatorShare": "No creator-share strategy",
  "product.extendedInvites": "Extended invites",
  "product.graduationPoints": "Graduation points",
  "product.inviteCodeUnavailable": "Invite code unavailable",
  "product.inviteInputPlaceholder": "e.g. KKTSFR37 or paste an invite link",
  "product.latestApiData": "Latest account API data",
  "product.launchRevenueProjects": "Launch revenue projects",
  "product.myRewardTokens": "My reward tokens",
  "product.chooseTokenToViewRewards":
    "Choose a token to review and claim its rewards.",
  "product.rewardTokenList": "Reward tokens",
  "product.rewardRulesSummary": "Reward rules and estimate details",
  "product.launchRevenueUnavailable":
    "Launch revenue could not be read from the current contracts.",
  "product.levelOneReferrals": "Level 1 referrals",
  "product.levelTwoPlusReferrals": "Level 2+ referrals",
  "product.activitySignIn":
    "You are not signed in. Sign in to view account activity.",
  "product.noActivityRecords": "No matching points activity",
  "product.noCreatorLaunches":
    "No creator income or token-weighted dividends are currently claimable by this wallet.",
  "product.oneClickClaimHint":
    "Revenue has not reached your wallet yet. Claim can try settlement using your current permissions.",
  "product.noVestingRecords": "No release records yet.",
  "product.nothingToClaim": "Nothing to claim",
  "product.pendingDistribution": "Pending distribution",
  "product.pendingFeesValue": "Pending {{amount}} {{symbol}}",
  "product.portfolioApiUnavailable": "Account data is temporarily unavailable",
  "product.pointsRanking": "Points ranking",
  "product.rankingSettledPoints": "Settled points · Top 100",
  "product.rankingRank": "Rank",
  "product.rankingYou": "You",
  "product.rankingSignIn": "Sign in to view the points ranking.",
  "product.rankingUnavailable":
    "The points ranking is temporarily unavailable.",
  "product.rankingEmpty": "No ranked users yet.",
  "product.revenueSignIn":
    "You are not signed in. Sign in to view and claim revenue.",
  "product.referralNetwork": "Referral network",
  "product.referralPoints": "Referral points",
  "product.referrerAlreadyBound": "A referrer is already bound",
  "product.referrerBindFailed": "Could not bind referrer",
  "product.revenueClaimConfirmed":
    "Done. Any available personal revenue was sent to your wallet.",
  "product.revenueClaimFailed": "Revenue claim did not complete",
  "product.projectRevenueClaimConfirmed":
    "The {{symbol}} claim was confirmed. Revenue data is refreshing.",
  "product.projectRevenueClaimFailed":
    "{{symbol}} revenue claim did not complete",
  "product.projectRevenueClaimRequiresSettlement":
    "{{symbol}} revenue has not been settled",
  "product.revenueClaimRequiresSettlement":
    "The estimated addition is not yet claimable. Settle the project first, then claim after the confirmed data refresh.",
  "product.revenueClaimRetry":
    "Simulation or on-chain execution failed. Refresh the revenue data, check the wallet state, and try again.",
  "product.projectRevenueGasLimitReduced":
    "The wallet submitted a lower gas limit ({{submitted}}) than requested ({{requested}}), so some claim actions did not run. Retry after confirming the wallet did not reduce the gas limit.",
  "product.settleProjectRevenue": "Settle {{symbol}} revenue",
  "product.normalizeProjectFees": "Convert fees",
  "product.feeNormalizationRequiresMigration":
    "Outer-market fees can be converted after graduation.",
  "product.feeNormalizationRequired": "Fee conversion required",
  "product.pendingTokenFeeBreakdown":
    "Collected {{collected}} · At source {{source}}",
  "product.feeNormalizationConfirmed":
    "{{symbol}} fees were converted to the pair asset. On-chain data is refreshing.",
  "product.feeNormalizationFailed":
    "{{symbol}} fee conversion did not complete",
  "product.settlementReadiness": "Settlement readiness",
  "product.settlementReady": "Ready to settle",
  "product.settlementIdle": "No unsettled revenue",
  "product.accruedSettlementFees": "Accrued at revenue source",
  "product.pendingQuoteFees": "Pending in settlement pool",
  "product.pendingTokenFees": "Pending Meme token fees",
  "product.pendingStrategyModules": "Pending / all strategies",
  "product.projectRevenueSettlementConfirmed":
    "{{symbol}} revenue was settled. Claimable amounts are refreshing.",
  "product.projectRevenueSettlementFailed":
    "{{symbol}} revenue settlement did not complete",
  "product.projectRevenueAtomicSettlementFailed":
    "Settlement simulation or execution failed because on-chain state changed or the current step is not executable. Refresh and try again.",
  "product.projectStrategyOperations": "Strategy operations",
  "product.projectStrategyOperationsDescription":
    "Project strategies become viewable and executable after the token graduates and completes its V4 migration.",
  "product.revenueInnerMarketStage": "Inner-market stage",
  "product.revenueAwaitingGraduation": "Available after graduation",
  "product.revenueInnerMarketNoticeTitle":
    "Project strategies do not execute during the inner market",
  "product.revenueInnerMarketNoticeDescription":
    "Fees can still be settled and collected during the inner market: the platform share is recorded normally while the project-strategy share remains locked. Outer-market buybacks, dividend reward conversion, and personal claims become available only after graduation and V4 migration.",
  "product.lockedProjectFees": "Locked project share",
  "product.settledFeesTotal": "Total settled",
  "product.onchainState": "Live on-chain state",
  "product.dividendRewardConversion": "Dividend reward conversion",
  "product.convertDividendReward": "Convert reward",
  "product.dividendConversionDescription":
    "Convert the collected dividend budget into {{asset}} and deposit it into strategy reward inventory. It is not sent to the executor wallet.",
  "product.dividendConversionConfirmed":
    "{{symbol}} dividend reward conversion succeeded. On-chain data is refreshing.",
  "product.dividendConversionFailed":
    "{{symbol}} dividend reward conversion failed",
  "product.requestingExecutionQuote": "Getting quote",
  "product.validatingExecutionQuote": "Checking on-chain state",
  "product.simulatingTransaction": "Simulating transaction",
  "product.awaitingWalletConfirmation": "Waiting for wallet signature",
  "product.confirmingOnchainTransaction": "Confirming on-chain",
  "product.executionQuoteTimeout":
    "The quote service timed out. Request a fresh quote and try again.",
  "product.executionQuoteExpired":
    "The quote expired. Start the operation again to request a fresh quote.",
  "product.rewardPoolUnavailable":
    "No valid reward pool is configured for this quote asset. The platform must configure the pool before conversion.",
  "product.executionQuoteValidationFailed":
    "The quote does not match the current on-chain configuration or safety limits, so the transaction was not submitted.",
  "product.innerBuyback": "Inner-market buyback and burn",
  "product.executeInnerBuyback": "Execute inner buyback",
  "product.innerBuybackDescription":
    "Use strategy budget to buy {{symbol}} from the bonding curve and burn it atomically. Tokens are not sent to the executor wallet.",
  "product.innerBuybackConfirmed":
    "{{symbol}} inner-market buyback and burn succeeded. On-chain data is refreshing.",
  "product.innerBuybackFailed": "{{symbol}} inner-market buyback failed",
  "product.executeOuterBuyback": "Execute outer-market buyback",
  "product.outerBuybackDescription":
    "Use strategy budget to buy {{symbol}} from its graduated V4 pool and burn it in the same transaction. Tokens are not sent to the executor wallet.",
  "product.outerBuybackConfirmed":
    "{{symbol}} outer-market buyback and burn succeeded. On-chain data is refreshing.",
  "product.outerBuybackFailed": "{{symbol}} outer-market buyback failed",
  "product.buybackAndBurn": "Buyback and burn",
  "product.buybackMarketInner": "Inner market",
  "product.buybackMarketOuter": "Outer market",
  "product.strategyBudget": "Strategy budget",
  "product.buybackBudget": "Available buyback budget",
  "product.buybackExecutionLimit": "Available this time",
  "product.buybackTotalSpent": "Total spent",
  "product.buybackTotalBurned": "Total burned",
  "product.buybackStatusReady": "Ready",
  "product.buybackStatusConnectWallet": "Connect wallet",
  "product.buybackStatusNoPermission": "No permission",
  "product.buybackStatusDisabledAtLaunch": "Disabled at launch",
  "product.buybackStatusOuterUnavailable": "Outer market unavailable",
  "product.buybackStatusOuterUnavailableDescription":
    "This project is on the outer market. Buyback data remains visible, while outer-market execution is reserved for a later release.",
  "product.buybackStatusTradingUnavailable": "Trading unavailable",
  "product.buybackStatusWaitingBudget": "Waiting for budget",
  "product.buybackStatusLimitUnavailable": "Limit unavailable",
  "product.walletRequestRejected": "You cancelled the wallet request.",
  "product.strategyOperationRetry":
    "Quote, simulation, or on-chain execution did not complete. Refresh the on-chain data and try again.",
  "product.claimCreatorRevenue": "Claim creator revenue",
  "product.claimDividendRevenue": "Claim holder dividend",
  "product.creatorRevenueClaimConfirmed":
    "{{symbol}} creator revenue was sent to your wallet.",
  "product.dividendRevenueClaimConfirmed":
    "{{symbol}} holder dividend was sent to your wallet.",
  "product.claimProjectRevenue": "Claim {{symbol}} revenue",
  "product.claimSuccessful": "Claim successful",
  "product.creatorRevenueEstimate": "Creator revenue",
  "product.creatorRevenueDescription":
    "Trading revenue allocated to the launch creator by the selected strategy.",
  "product.dividendRevenueDescription":
    "Calculated from this Meme's token weight and dividend snapshots.",
  "product.revenueEstimateDisclaimer":
    "Estimated claimable total equals the currently claimable balance plus the amount expected from this action. Creator additions require settlement; dividend inventory can create a snapshot during claiming. Gas is excluded.",
  "product.revenueEstimateIncomplete":
    "Some strategy estimates are incomplete; missing income must not be treated as zero.",
  "product.revenueEstimateUnavailable":
    "Contract estimate is unavailable. Only already accrued claimable amounts are shown below.",
  "product.revenueEstimatedTotal": "Estimated claimable this time",
  "product.revenueCurrentClaimable": "Currently claimable",
  "product.creatorRevenueCurrentClaimableShared":
    "Currently claimable (shared asset balance)",
  "product.creatorRevenueEstimatedAdditional":
    "Estimated addition after settlement",
  "product.dividendRevenueEstimatedAdditional":
    "Estimated addition from new snapshot",
  "product.revenueHistoricalClaimed": "Historically claimed total",
  "product.revenueAmountPending": "Determined after on-chain settlement",
  "product.revenueReady": "Claimable",
  "product.revenueAwaitingSettlement": "Awaiting settlement",
  "product.revenueAwaitingConversion": "Awaiting reward conversion",
  "product.revenueRouterUnavailable":
    "The current Factory is not connected to the latest revenue contracts. Launch and settlement are unavailable.",
  "product.weightedDividend": "Token-weighted dividend",
  "product.dividendAwaitingSnapshot":
    "New rewards can be snapshotted when claiming",
  "product.revenuePolicyDisabled": "Revenue policy disabled",
  "product.settlementAsset": "Settlement asset: {{asset}}",
  "product.settlementAssetLabel": "Payout asset",
  "product.singleProjectTransaction": "One Meme · one transaction",
  "product.revenueProjectClaimNotice":
    "During the inner market, only executable revenue settlement is shown and project-strategy funds remain locked. Outer-market buybacks, dividend reward conversion, and personal claims appear after graduation and V4 migration.",
  "product.revenueProjectCount": "{{count}} revenue projects",
  "product.onchainExecutionDetails": "On-chain execution details",
  "product.projectContract": "Meme contract",
  "product.policyVersion": "Revenue policy version",
  "product.strategyCount": "Project strategy count",
  "product.transactionWillAttempt": "This transaction will attempt",
  "product.revenueStepCreator": "Claim creator revenue for this wallet",
  "product.revenueStepDividend":
    "Create an available dividend snapshot and claim token-weighted dividends",
  "product.totalNetwork": "Total network",
  "product.tradePoints": "Trading points",
  "product.pointsAndRewards": "Points / Reward estimates",
  "product.pointsBreakdown": "Points breakdown and estimated rewards",
  "product.innerMarket": "Inner-market trades",
  "product.outerMarket": "Outer-market trades",
  "product.estimatedReward": "Estimated reward",
  "product.rewardEstimateNotice":
    "Estimates change with network-wide points and graduated-token totals. Final rewards are determined at campaign settlement.",
  "product.claimSubmittedToast": "Claim submitted for confirmation.",
  "product.vestingClaimSubmittedToast":
    "Vesting claim submitted for confirmation.",
  "product.referrerBoundToast": "Referrer binding submitted.",
  "product.inviteLinkCopied": "Invite link copied.",
  "product.contractAddressUnavailable":
    "The OURS contract address is not configured yet.",
  "product.129mBurned": "1.29M burned",
  "product.12ActiveThisWeek": "12 active this week",
  "product.12MonthLinearRelease": "12-month linear release",
  "product.198mBurned": "1.98M burned",
  "product.24hVolume": "24H volume",
  "product.3Graduated": "3 graduated",
  "product.4HoursAgo": "4 hours ago",
  "product.8MinutesAgo": "8 minutes ago",
  "product.accountActivity": "Account activity",
  "product.accountActive": "Activated",
  "product.accountApproved": "Approved",
  "product.accountBound": "Bound",
  "product.accountInactive": "Not activated",
  "product.accountMenu": "Account menu",
  "product.accountPending": "Pending review",
  "product.accountRejected": "Not approved",
  "product.accountUnbound": "Not bound",
  "product.allowlist": "Allowlist",
  "product.applicationStatus": "Application status",
  "product.xBindingBenefitIdentity":
    "Use your public X identity across the OURS community.",
  "product.xBindingBenefitNoPosting":
    "OURS cannot publish or modify posts on your behalf.",
  "product.xBindingBenefitPublicProfile":
    "Only your public profile and avatar are displayed.",
  "product.xBindingCancel": "Cancel",
  "product.xBindingCancelled":
    "X authorization was cancelled. You can try again when ready.",
  "product.xBindingChecking": "Checking X connection…",
  "product.xBindingClose": "Close X connection dialog",
  "product.xBindingConnect": "Connect X",
  "product.xBindingConnectHint": "Add your public social identity",
  "product.xBindingConnected": "Connected",
  "product.xBindingConsent":
    "I agree to share my public X profile with OURS for account identification.",
  "product.xBindingContinue": "Continue to X",
  "product.xBindingDescription":
    "Connect your X account to make your OURS identity easier to recognize.",
  "product.xBindingDone": "Done",
  "product.xBindingExpired":
    "This X authorization has expired. Start a new connection to continue.",
  "product.xBindingFailed": "Connection failed",
  "product.xBindingFailedDescription":
    "We could not connect your X account. Please start the authorization again.",
  "product.xBindingFinishing": "Finishing your X connection…",
  "product.xBindingOccupied": "Already connected elsewhere",
  "product.xBindingOccupiedDescription":
    "This X account is already connected to another OURS account.",
  "product.xBindingPending": "Waiting for X",
  "product.xBindingPendingDescription":
    "Complete authorization in the X window. Keep this window open while we verify it.",
  "product.xBindingPopupBlocked":
    "Your browser blocked the X window. Allow pop-ups for this site, then try again.",
  "product.xBindingRetryCheck": "Select to check again",
  "product.xBindingSucceeded": "X account connected.",
  "product.xBindingSuccessDescription":
    "Your X profile is now connected. Its avatar will be used in the account menu.",
  "product.xBindingTitle": "Connect X account",
  "product.xBindingTryAgain": "Try again",
  "product.xBindingUnavailable": "X status unavailable",
  "product.xBindingWindowClosed":
    "The X window was closed before authorization finished.",
  "product.advanced": "Advanced",
  "product.enableAdvancedSettings": "Enable advanced settings",
  "product.afterClose": "After close",
  "product.afterGraduationUniswapV4PlusHookFee":
    "After graduation: Uniswap v4 + Hook fee.",
  "product.afterInvestment": "After investment",
  "product.aJoyfulMemeOwnedByItsContributors":
    "A joyful meme owned by its contributors.",
  "product.all": "All",
  "product.allocationPurpose": "Use for",
  "product.allocationRatio": "Allocation ratio",
  "product.allocationTotal": "Total",
  "product.allocationMustTotal100":
    "Each share must be a positive whole number, totaling 100%.",
  "product.allocationScenario": "Allocation scenario",
  "product.allocationFeeNote":
    "Strategy percentages allocate the project's {{share}}% share. They must total 100%.",
  "product.allocationSummaryBuyback":
    "Of your distributable revenue, {{share}}% goes to buybacks and {{retained}}% remains available for you to claim.",
  "product.allocationSummaryDividend":
    "Of your distributable revenue, {{share}}% goes to dividends and {{retained}}% remains available for you to claim.",
  "product.allocationIsFinalisedAfterTheRoundClosesItThenUnlocks":
    "Allocation is finalised pro rata after the round closes, then unlocks continuously over 12 months from TGE.",
  "product.allRobinhoodChainStockTokensAndEtfsCanBeDiscovered":
    "Available assets follow the Factory's on-chain configuration. The quote asset, graduation target, and permanent LP pair are locked at launch.",
  "product.amount": "AMOUNT",
  "product.anyoneCanTriggerTheFixedBatchWithProtocolFundsThe":
    "Anyone can trigger the fixed batch with protocol funds. The caller only signs and pays gas.",
  "product.assetNotShown": "ASSET NOT SHOWN?",
  "product.assets": "Assets",
  "product.at100TheMarketMigratesAutomaticallyToAUniswapV4":
    "At 100% the market migrates automatically to a Uniswap v4 pool.",
  "product.at1mRaised": "at $1M raised",
  "product.at2mRaised": "at $2M raised",
  "product.attributedFromTheInvitedUsersValidVolumeAndGraduationActivity":
    "Attributed from the invited users' valid volume and graduation activity.",
  "product.available": "Available",
  "product.availableBalance": "Available balance",
  "product.awaitingConfirmation": "Awaiting confirmation…",
  "product.backToExplore": "Back to Explore",
  "product.balance": "Balance",
  "product.balancePercentage": "Select a percentage of the available balance",
  "product.batchReady": "Batch ready",
  "product.bindYourReferrer": "BIND YOUR REFERRER",
  "product.botServiceFee": "Bot service fee",
  "product.bubuGraduated": "BUBU graduated",
  "product.burn": "Burn",
  "product.buy": "Buy",
  "product.buy2": "BUY",
  "product.buyback": "Buyback",
  "product.buybackBurn": "Buyback and burn",
  "product.buybackOnly": "Buyback",
  "product.buybackOnlyScenario": "Buyback only",
  "product.buybackAndDividends": "Buyback + dividends",
  "product.allRevenueStrategies": "Dev + buyback + dividends",
  "product.buybackSubmitted": "Buyback submitted!",
  "product.buyOurs": "Buy OURS",
  "product.calculatedFromSuccessfulOnChainVolumeMoreContributionEarnsMore":
    "Calculated from successful on-chain volume. More contribution earns more shares.",
  "product.chain4663WalletAndBotSdk": "Chain 4663 wallet and Bot SDK",
  "product.chainId4663RefreshedAtLaunch": "Chain ID 4663 · refreshed at launch",
  "product.charactersMax": "characters max",
  "product.chooseFromEthUsdcAndApprovedTokenisedStocksOneLaunch":
    "Choose an asset currently approved by the Factory. One launch uses one quote asset and it cannot be changed later.",
  "product.chooseOneApprovedQuoteAssetTheCurveGraduationTargetAnd":
    "Choose an asset currently approved by the Factory. The curve, graduation target, and permanent LP pair are fixed at launch.",
  "product.chooseTheLpQuoteAsset": "Choose the LP quote asset",
  "product.lpPairAssetCount": "{{count}} assets available",
  "product.scrollForMoreAssets": "Scroll for more",
  "product.claim16438Ours": "Claim 16,438 OURS",
  "product.claimableCreatorFees": "Claimable creator fees",
  "product.claimableNow": "Claimable now",
  "product.claimAll": "Claim all",
  "product.claimCenter": "Claim center",
  "product.claimed": "Claimed",
  "product.claims": "Claims",
  "product.claims2": "Claims",
  "product.closeLaunchDialog": "Close launch dialog",
  "product.closeSendDialog": "Close send dialog",
  "product.community0Pts": "Community · 0 pts",
  "product.communityExecution": "COMMUNITY EXECUTION",
  "product.communityRound": "Community Round",
  "product.confirmed": "Confirmed",
  "product.connect": "Sign in",
  "product.connectAndContributeEth": "Sign in and contribute ETH",
  "product.connectContributeEthOwnTogether":
    "Sign in. Contribute ETH. Own together.",
  "product.connectedWallet": "SIGNED-IN WALLET",
  "product.connectedWallet2": "Signed-in wallet",
  "product.connecting": "Connecting…",
  "product.connectToTrade": "Sign in to trade",
  "product.connectWallet": "Sign in",
  "product.connectWalletAndReview": "Sign in and review",
  "product.connectYourWalletToSeeContributionsFinalAllocationAndClaim":
    "Sign in to see contributions, final allocation and claim records.",
  "product.copyAddressFailed": "Unable to copy the wallet address.",
  "product.copyWalletAddress": "Copy wallet address",
  "product.continuousLinearUnlockNoOneTimeCliffRelease":
    "Continuous linear unlock; no one-time cliff release",
  "product.contract": "Contract",
  "product.contractCopied": "Contract copied ✓",
  "product.contractInterfaces": "Contract interfaces",
  "product.contributeAmountEth": "Contribute {{amount}} ETH",
  "product.contributeEthOnRobinhoodChainAndReceiveAProRata":
    "Contribute native ETH through the Robinhood Chain fundraising contract with every amount recorded on-chain.",
  "product.contributionAmount": "CONTRIBUTION AMOUNT",
  "product.contributionBecomesOwnership": "Contribution becomes ownership",
  "product.contributionEpoch08": "Contribution · Epoch 08",
  "product.contributionMining": "Contribution mining",
  "product.contributionReward": "Contribution reward",
  "product.contributionSubmitted": "Contribution submitted ✓",
  "product.copied": "Copied ✓",
  "product.copyLink": "Copy link",
  "product.creatorFee": "Creator fee",
  "product.creatorFee2": "CREATOR FEE",
  "product.creatorFeeWallet": "CREATOR FEE WALLET",
  "product.creator": "Creator",
  "product.creatorOnly": "Dev only",
  "product.creatorAndBuyback": "Dev + buyback",
  "product.creatorAndDividends": "Dev + dividends",
  "product.creatorRevenueAllocation": "Creator revenue allocation",
  "product.creatorJoyLaunched": "Creator · JOY launched",
  "product.creatorShareBuybackVault": "Creator-share buyback vault",
  "product.current": "Current",
  "product.currentPhase": "Current phase",
  "product.currentPrice": "CURRENT PRICE",
  "product.description": "DESCRIPTION",
  "product.dev": "Dev",
  "product.developerBuyOptional": "DEVELOPER BUY · OPTIONAL",
  "product.directInvites": "Direct invites",
  "product.disabled": "Disabled",
  "product.dividends": "Dividends",
  "product.dividendsOnly": "Dividends only",
  "product.dividendAsset": "Dividend asset",
  "product.dividendRules": "Dividend rules",
  "product.distributableRevenueRatio": "Distributable revenue ratio",
  "product.revenueAllocation": "Revenue allocation",
  "product.currentRevenuePolicy": "Protocol fee allocation",
  "product.loadingRevenuePolicy": "Reading on-chain policy…",
  "product.revenuePolicyUnavailable":
    "On-chain allocation is temporarily unavailable",
  "product.noRevenuePolicy": "No revenue allocation configured",
  "product.platformShare": "Platform share",
  "product.remainingFeeShare": "Project share",
  "product.remainingToGraduateLabel": "Still needed:",
  "product.userDividends": "User dividends",
  "product.otherRevenueStrategy": "Other on-chain strategy",
  "product.platformRevenue": "Platform revenue",
  "product.projectRevenueShare": "Project share",
  "product.projectRevenueStrategies": "Project revenue strategies",
  "product.platformShareHint":
    "Fixed at launch. Choose 30%–100%; 100% configures no project strategy.",
  "product.platformOnlyRevenueHint":
    "All fee revenue goes to the platform. No project strategy contract will be configured.",
  "product.creatorTradeTax": "Creator trade tax",
  "product.buySurcharge": "Buy surcharge",
  "product.revenueAllocationHint":
    "Choose how the project's {{share}}% share is used. These strategy ratios use the project share as their 100% base.",
  "product.buybackAvailabilityAfterGraduation":
    "Buybacks execute only after the token graduates and completes its V4 migration. No buyback runs during the inner market; its project share remains locked until graduation.",
  "product.dividendAvailabilityAfterGraduation":
    "Holder dividends become available only after graduation and V4 migration. The dividend share remains locked during the inner market, then is collected and distributed in the selected asset.",
  "product.buybackDividendAvailabilityAfterGraduation":
    "Buybacks and holder dividends both become available after graduation and V4 migration. Their project-strategy shares only accrue and remain locked during the inner market.",
  "product.enableRevenueAllocation": "Enable revenue allocation",
  "product.revenueAllocationEnabledSummary":
    "On · revenue follows the selected contract strategies",
  "product.revenueAllocationPlatformOnlySummary":
    "100% platform · no project strategy",
  "product.revenueAllocationSplitSummary":
    "{{platform}}% platform · {{project}}% project",
  "product.strategyAvailabilityLoading":
    "Checking on-chain revenue strategies…",
  "product.strategyAvailabilityReadFailed":
    "Unable to read the on-chain strategy catalogue. Try again later.",
  "product.strategyUnavailable":
    "A selected revenue strategy is unregistered, paused, or unavailable for new launches.",
  "product.discoverLiveBondingCurvesAndGraduatedUniswapV4MarketsPaired":
    "Discover live bonding curves and graduated Uniswap v4 markets using the Factory's approved quote assets.",
  "product.dynamicQuote": "Dynamic quote",
  "product.eachAssetIsClaimedFromItsOwnOnChainBalance":
    "Each asset is claimed from its own on-chain balance.",
  "product.economicsAndOpeningBuy": "Economics and opening buy",
  "product.enabled": "Enabled",
  "product.end": "End",
  "product.enterACodeOrPasteTheCompleteInviteLinkBefore":
    "Enter a code or paste the complete invite link before your first contribution.",
  "product.enterAnEthAmountAbove": "Enter an ETH amount above",
  "product.epoch08": "Epoch 08",
  "product.est124800Ours": "Est. 124,800 OURS",
  "product.estimatedAllocation": "Estimated allocation",
  "product.estimatedOursFromThe20Pool":
    "Estimated {{symbol}} from the 20% pool",
  "product.estimatedShareOfTotalSupply": "Estimated share of total supply",
  "product.estimatedUsdValue": "Estimated USD value",
  "product.estReceive": "EST. RECEIVE",
  "product.ethIsConvertedAtTheLiveExecutionQuoteTheDisplayed":
    "Displayed values use the live ETH/USDT market quote; the on-chain contribution remains native ETH.",
  "product.everyCompletedGraduationCountsMultipleSuccessfulProjectsCanEarnMultiple":
    "Every completed graduation counts. Multiple successful projects can earn multiple shares.",
  "product.everyDayUntil20270701": "Every day until 2027-07-01",
  "product.everyTermIsPreviewedBeforeSigningAndRemainsFixedFor":
    "Every term is previewed before signing and remains fixed for this launch.",
  "product.executedAtomicallyWithLaunch": "Executed atomically with launch",
  "product.invalidDeveloperBuy":
    "Enter a valid developer buy amount greater than or equal to 0.",
  "product.initialPurchase": "Initial purchase",
  "product.initialPurchaseHint":
    "Optionally buy your own token in the launch transaction.",
  "product.curveTradingFee": "Inner-market trading fee",
  "product.curveTradingFeeValue": "{{fee}}%",
  "product.curveTradingFeeHint":
    "Sets the base fee on each bonding-curve buy and sell, fixed after launch. It does not control the graduated pool's core fee, which is currently 0.",
  "product.curveTradingFeeRange":
    "{{count}} on-chain steps from {{minimum}}% to {{maximum}}%",
  "product.initialBuyAmount": "Pair asset amount to spend",
  "product.initialBuyPlaceholder": "0 · Skip initial purchase",
  "product.initialBuyHelp":
    "Leave blank or enter 0 to skip. Amounts above 0 execute atomically with launch; the token output is simulated before signing.",
  "product.estimatedInitialBuyTokens": "Estimated tokens received",
  "product.initialBuyEstimateLoading": "Reading curve pricing parameters…",
  "product.initialBuyEstimateUnavailable":
    "Unable to estimate token output right now",
  "product.initialBuyTooSmall":
    "Amount too small; estimated output is 0 tokens",
  "product.initialBuyEstimateHint":
    "Calculated from the selected pair's on-chain bonding-curve parameters, fee, and sellable supply. Any unfilled amount is refunded. The transaction is simulated again before signing; actual output follows the transaction.",
  "product.invalidSnipeTaxExemptions":
    "Snipe-tax exemptions must be valid addresses, with at most 32 entries.",
  "product.explore": "Explore",
  "product.explore2": "Explore",
  "product.externalRouteDiscovery": "External route discovery",
  "product.feeAllocation": "Fee allocation",
  "product.feeSplitProjectPlatform": "Fees (project / platform)",
  "product.feeEnforcement": "Fee enforcement",
  "product.feeExecutorOnline": "Fee executor online",
  "product.feePlusRouteExecution": "Fee + route execution",
  "product.feesBuyBackOurs":
    "The platform fee share buys back OURS under the allocation policy",
  "product.feesToBuyback": "FEES TO BUYBACK",
  "product.finalTokenAllocationIsSettledProRataAgainstThe20":
    "Estimated Token allocation uses live on-chain fundraising data, platform valuation and the current reference price; final allocation settles after the round closes.",
  "product.firstClaim": "First claim",
  "product.fixedAfterLaunch": "Fixed after launch",
  "product.fixedBatch": "FIXED BATCH",
  "product.fromFundsRaised": "From funds raised",
  "product.fundingStructure": "Funding structure",
  "product.fundraising": "Fundraising",
  "product.fundraising2": "Fundraising",
  "product.fundraising3": "Fundraising",
  "product.fundraisingAllocation": "Fundraising allocation",
  "product.fundraisingProgress": "Fundraising progress",
  "product.fundraisingRange": "Fundraising range",
  "product.graduate": "Graduate",
  "product.graduated": "Graduated",
  "product.graduated2": "graduated",
  "product.graduatedTrades": "Graduated trades",
  "product.graduateToUniswapV4": "Graduate to Uniswap v4",
  "product.graduation": "Graduation",
  "product.graduation2": "Graduation",
  "product.graduation3": "Graduation",
  "product.graduation4": "Graduation",
  "product.graduation5": "Graduation",
  "product.graduationLiquidity": "Graduation liquidity",
  "product.graduationPool": "graduation pool",
  "product.graduationProgress": "GRADUATION PROGRESS",
  "product.graduationTargetReached": "Graduation target reached",
  "product.graduationRoute": "Graduation route",
  "product.haveAnInviteCode": "Have an invite code?",
  "product.holders": "Holders",
  "product.imageSelected": "Image selected",
  "product.invitation": "Invitation",
  "product.invitationData": "Invitation data",
  "product.invite": "Invite",
  "product.inviteAttribution": "Invite attribution",
  "product.inviteBound": "Invite bound",
  "product.inviteCodeOrLink": "INVITE CODE OR LINK",
  "product.invitePoints": "Invite points",
  "product.invites": "Invites",
  "product.inviteBinding": "Invite binding",
  "product.joyTogether": "Joy Together",
  "product.justNow": "Just now",
  "product.keeperOnline": "KEEPER ONLINE",
  "product.lastSweep6MinutesAgo": "Last sweep 6 minutes ago",
  "product.launch": "Launch",
  "product.launched": "Launched",
  "product.launchedToday": "launched today",
  "product.launchDialogDescription":
    "Complete the project profile and choose its market. You will review every key term again before signing in your wallet.",
  "product.launchDialogHeadline": "Create your Meme Token",
  "product.launchDialogKicker": "OURS Launchpad · Robinhood Chain",
  "product.launchFee": "Launch fee",
  "product.launchImageHint": "PNG / JPG / GIF / BMP · up to 5 MB",
  "product.launchMarketDescription":
    "Choose one Factory-approved quote asset. The curve, graduation target, and permanent liquidity pair stay fixed after launch.",
  "product.launchNeedsAttention": "Complete the required details to launch",
  "product.launchOnRobinhood": "Launch on Robinhood",
  "product.launchPreview": "Live preview",
  "product.launchProfileDescription":
    "This is how the project appears across discovery and trading. Name, ticker, and image are required.",
  "product.launchReady": "Launch details are ready",
  "product.launchReviewReady": "Launch review ready",
  "product.launchToken": "Launch token",
  "product.login": "Sign in",
  "product.loginAndReview": "Sign in and review",
  "product.loggingIn": "Signing in…",
  "product.linear": "Linear",
  "product.linearReleaseOver12MonthsFromTge":
    "Linear release over 12 months from TGE",
  "product.liquidity": "Liquidity",
  "product.live": "Live",
  "product.liveLinearVest": "Live linear vest",
  "product.liveTokens": "Live tokens",
  "product.lockedForever": "Locked forever",
  "product.lpPair": "LP pair",
  "product.marketCap": "Market cap",
  "product.marketData": "Market data",
  "product.marketLiquidity": "Market liquidity",
  "product.marketLiquidityAndTokenMarketBuilding":
    "Fundraising proceeds for market liquidity and Token market building",
  "product.marketsCurveAndUniswapV4": "markets · curve and Uniswap v4",
  "product.memePositions": "Meme positions",
  "product.migrating": "Migrating",
  "product.minReceived": "Min. received (1% slippage)",
  "product.monthlyUnlock12Months": "Monthly unlock · 12 months",
  "product.myOurs": "My OURS",
  "product.myOurs2": "My OURS",
  "product.mySubscription": "My subscription",
  "product.name": "NAME",
  "product.nativeGas": "native gas",
  "product.nearGraduation": "Near graduation",
  "product.netQuoteAfterAllFees": "Net quote after all fees",
  "product.networkContribution": "Network contribution",
  "product.networkVolume": "Network volume",
  "product.newest": "Newest",
  "product.noCap": "No cap",
  "product.noContributionYet": "No contribution yet",
  "product.noCycleCap": "No cycle cap",
  "product.now": "now",
  "product.onChain": "On-chain",
  "product.onChainReceipts": "On-chain receipts",
  "product.oneCenterForAssetsEarningsPointsInvitationsAndVesting":
    "One center for assets, earnings, points, invitations and vesting.",
  "product.oneFeeLayerMultipleRoutes": "One fee layer. Multiple routes.",
  "product.oneWalletCanBindOneReferrerOnly":
    "One wallet can bind one referrer only.",
  "product.only": "ONLY",
  "product.openingBuyRecipient": "OPENING BUY RECIPIENT",
  "product.openingBuyUnavailable":
    "The Factory has no atomic opening-buy router configured.",
  "product.openIntegration": "Open integration",
  "product.openWalletAccount": "Open wallet account",
  "product.openAccountMenu": "Open account menu for {{account}}",
  "product.oursHoldings": "OURS holdings",
  "product.oursHome": "ours home",
  "product.oursToken": "OURS Token",
  "product.overview": "Overview",
  "product.paidInTheSelectedQuoteAsset": "Paid in the selected quote asset",
  "product.pasteAnyRobinhoodChainStockTokenOrEtfContractThe":
    "Paste a Robinhood Chain ERC-20 contract. The launch flow verifies its metadata, Factory pricing, and Registry status before enabling it.",
  "product.pending": "Pending",
  "product.pendingExecution": "Pending execution",
  "product.permanentLiquidity": "Permanent liquidity",
  "product.planningRange": "Planning range",
  "product.platformFees": "Platform fees",
  "product.platformTokenFundingStructureBuybackAndRobinhoodChainTradingInfrastructu":
    "Platform Token, funding structure, buyback and Robinhood Chain trading infrastructure.",
  "product.points": "Points",
  "product.poolLinearVesting": "Pool · linear vesting",
  "product.portfolioValue": "Portfolio value",
  "product.preGraduationTrades": "Pre-graduation trades",
  "product.price": "PRICE",
  "product.priceImpact": "Price impact",
  "product.primaryNavigation": "Primary navigation",
  "product.privateRoundAllocation": "PRIVATE ROUND ALLOCATION",
  "product.privateVesting": "Private vesting",
  "product.privyWalletsAndTradingBotsCallOursGatewayOnChain":
    "Privy wallets and Trading Bots call OURS Gateway on Chain ID 4663. The contract charges the configured Bot fee and verifies the market phase before routing.",
  "product.productAndOperations": "Product & operations",
  "product.productAndOperations2":
    "Fundraising proceeds for product development and operations",
  "product.projectGraduation": "Project graduation",
  "product.protocolBotSettlement": "Protocol / Bot settlement",
  "product.protocolFee": "Protocol fee",
  "product.protocolFeesAreEnforcedByTheCurveAndUniswapV4":
    "Protocol fees are enforced by the Curve and Uniswap v4 Hook on Robinhood Chain. Eligible trading fees are split {{projectPercent}}% to projects and {{platformPercent}}% to the platform. Bot service fees are enforced by TradingGateway for orders originating from each Bot.",
  "product.quoteAsset": "Quote asset",
  "product.raisedAfterContribution": "Raised after contribution",
  "product.ready": "Ready",
  "product.recentTrades": "Recent trades",
  "product.recipient": "RECIPIENT",
  "product.records": "Records",
  "product.referrerBound": "REFERRER BOUND",
  "product.released": "released",
  "product.released2": "Released",
  "product.releaseSchedule": "Release schedule",
  "product.remaining": "Remaining",
  "product.resolvePhaseAndVenue": "Resolve phase and venue",
  "product.reviewAndSend": "Review and send",
  "product.reviewLaunch": "Review launch",
  "product.reviewTrade": "Review trade",
  "product.rewardClaim": "Reward claim",
  "product.rewardsFollowInvitationDataSuccessfulTradingVolumeAndProjectGraduation":
    "Rewards follow invitation data, successful trading volume and project graduation.",
  "product.robinhoodAssetRegistry": "ROBINHOOD ASSET REGISTRY",
  "product.robinhoodChainNativeAssetChainId4663":
    "Robinhood Chain native asset · Chain ID 4663",
  "product.robinhoodChainRoute": "Robinhood Chain route",
  "product.robinhoodNativeAsset": "Robinhood native asset",
  "product.robinhoodRegistryAsset": "Robinhood Registry asset",
  "product.roundStatus": "Round status",
  "product.routeAndContract": "Route & contract",
  "product.searchAllRobinhoodAssets": "SEARCH ALL ROBINHOOD ASSETS",
  "product.searchSymbolCompanyOrEtf": "Search symbol, company or ETF",
  "product.searchTokenPairOrAddress": "Search token, pair or address",
  "product.sell": "Sell",
  "product.sell2": "SELL",
  "product.send": "Send",
  "product.sendAssets": "Send assets",
  "product.sendJoy": "Send JOY",
  "product.sendToken": "Send token",
  "product.sendToken2": "SEND TOKEN",
  "product.settlement": "Settlement",
  "product.skipToContent": "Skip to content",
  "product.signInExplanation":
    "Sign a message to load your OURS profile. This does not submit a transaction or spend gas.",
  "product.signatureCancelled": "Signature cancelled.",
  "product.signInFailed": "Sign-in failed",
  "product.signInFailedHint":
    "The signature was not accepted. Try again when ready.",
  "product.signInSucceeded": "Signed in to OURS.",
  "product.signInWithWallet": "Sign in with wallet",
  "product.signedIn": "Signed in",
  "product.signedOut": "Signed out and wallet disconnected.",
  "product.signingIn": "Waiting for signature…",
  "product.signOut": "Sign out",
  "product.slippageProtectionKeeperFallbackNoRewardPoints":
    "Slippage protection · Keeper fallback · no reward points",
  "product.snipeTaxExemptWallets": "SNIPE-TAX EXEMPT WALLETS",
  "product.snipeTaxExemptionHint":
    "Separate up to 32 addresses with commas, spaces, or new lines. The launcher and creator recipient are exempted automatically.",
  "product.stockAssets": "stock assets",
  "product.stocksAndEtfsSynced": "stocks & ETFs synced",
  "product.stockTokenEligibility": "Stock token eligibility",
  "product.storedWithTheLaunchAndShownAcrossDiscoverySurfaces":
    "Stored with the launch and shown across discovery surfaces.",
  "product.submitted": "Submitted ✓",
  "product.submitted2": "Submitted",
  "product.supply": "Supply",
  "product.switchNetwork": "Switch network",
  "product.switchToChain": "Switch to {{chain}}",
  "product.telegram": "TELEGRAM",
  "product.thePeopleWhoBuildTheMarketOwnIt":
    "The people who build the market, own it.",
  "product.theRouteIsVerifiedOnchainBeforeExecution":
    "The route is verified onchain before execution.",
  "product.thisRelationshipIsPermanentlyRecordedOnchain":
    "This account relationship has been saved and cannot be changed.",
  "product.thisRoundAcceptsNativeEthOnlyOnRobinhoodChainIt":
    "This round accepts native ETH only on Robinhood Chain. At $1M raised the valuation is $5M, then grows continuously to a $10M valuation at $2M. The community shares a fixed 20% Token pool pro rata.",
  "product.ticker": "TICKER",
  "product.time": "Time",
  "product.toggleTheme": "Toggle theme",
  "product.token": "TOKEN",
  "product.tokenAllocation": "Token allocation",
  "product.tokenImage": "Token image",
  "product.tokenMarket": "Token market",
  "product.tokenPositions": "Token positions",
  "product.tokenProfile": "Token profile",
  "product.tokenSent": "Token sent",
  "product.totalBought": "Total bought",
  "product.totalBurned": "Total burned",
  "product.totalClaimed": "Total claimed",
  "product.totalPoints": "Total points",
  "product.trade": "Trade",
  "product.tradeOnCurve": "Trade on curve",
  "product.tradeReviewReady": "Trade review ready",
  "product.tradeOurs": "Trade OURS",
  "product.trader48Trades": "Trader · 48 trades",
  "product.trades": "Trades",
  "product.tradesGraduationBuyback": "Trades, graduation, buyback",
  "product.tradingContract": "Trading contract",
  "product.tradingGateway": "Trading Gateway",
  "product.tradingInfrastructure": "Trading infrastructure",
  "product.tradingVolume": "Trading volume",
  "product.tradingVolume2": "Trading volume",
  "product.transactionSubmitted": "Transaction submitted",
  "product.transfers": "Transfers",
  "product.treasury": "Treasury",
  "product.treasury2": "Treasury",
  "product.trending": "Trending",
  "product.trigger1000UsdtBuyback": "Trigger 1,000 USDT buyback",
  "product.triggerTheNextBatch": "Trigger the next batch",
  "product.type": "Type",
  "product.unsignedGatewayTransaction": "Unsigned Gateway transaction",
  "product.valuation": "Valuation",
  "product.valuationAfterContribution": "Valuation after contribution",
  "product.valuationFinalTotalRaised5ItIsCalculatedAutomaticallyAnd":
    "Current valuation uses the contract's total raised; the entered contribution and live ETH/USDT market quote determine the projected valuation.",
  "product.verified": "Verified",
  "product.verified2": "Verified ✓",
  "product.verifyAndBind": "Verify and bind",
  "product.verifyAsset": "Verify asset",
  "product.vestedPrivateTokens": "Vested private tokens",
  "product.vesting": "Vesting",
  "product.viewFeeFlywheel": "View fee flywheel",
  "product.volume": "Volume",
  "product.waitingForConfirmationThisActionGeneratesZeroPoints":
    "Waiting for confirmation. This action generates zero points.",
  "product.wallet": "Wallet",
  "product.wallet2": "Wallet",
  "product.walletAndSigning": "Wallet & signing",
  "product.walletAddressCopied": "Wallet address copied.",
  "product.walletConnected": "Wallet connected",
  "product.walletNotConnected": "Not signed in",
  "product.website": "WEBSITE",
  "product.xProfile": "X PROFILE",
  "product.youPay": "YOU PAY",
  "product.yourInviteLink": "YOUR INVITE LINK",
  "product.yourToken": "Your token",
  "product.yourWalletSubmitsTheLaunchTransactionOursDoesNotCustody":
    "Your wallet submits the launch transaction. OURS does not custody launch assets.",
  "product.tryAgain": "Try again.",
  "product.remainingBeforeHardCap":
    "Only ${{amount}} remains before the hard cap.",
  "product.contributed": "Contributed",
  "product.depositors": "depositors",
  "product.fundraisingAccountLimit":
    "This contribution exceeds your cumulative wallet limit.",
  "product.fundraisingAmountRequired": "Enter a valid contribution amount.",
  "product.fundraisingBelowMinimum":
    "The amount is below the contract minimum.",
  "product.fundraisingClosedMessage":
    "The fundraising contract is not accepting contributions.",
  "product.fundraisingConfirmed": "Contribution confirmed onchain.",
  "product.fundraisingValue": "Fundraising",
  "product.fundraisingGlobalLimit":
    "This contribution exceeds the remaining global cap.",
  "product.fundraisingInsufficientBalance":
    "The wallet needs enough ETH for the contribution and gas.",
  "product.fundraisingNativeOnlyNotice":
    "Contributions use native ETH and are forwarded to the contract receiving address immediately.",
  "product.fundraisingOnChainIntro":
    "Live limits, totals and wallet allocation read directly from the Robinhood Mainnet fundraising contract.",
  "product.fundraisingReadFailed":
    "Unable to read the fundraising contract. Check the RPC connection and try again.",
  "product.fundraisingPriceReadFailed":
    "The ETH/USDT market quote is temporarily unavailable. USDT values will appear when pricing recovers.",
  "product.fundraisingStatus": "Fundraising status",
  "product.fundraisingStatus.cap-reached": "Cap reached",
  "product.fundraisingStatus.closed": "Not open",
  "product.fundraisingStatus.open": "Open",
  "product.fundraisingSubmitFailed":
    "The on-chain preflight failed. The contract is not accepting this contribution.",
  "product.globalRemaining": "Global remaining",
  "product.maximumPerWallet": "Maximum per wallet",
  "product.minimumPerDeposit": "Minimum per deposit",
  "product.readDirectlyFromContract": "Read directly from contract",
  "product.receivingAddress": "Receiving address",
  "product.totalRaised": "Total raised",
  "product.yourContribution": "Your contribution",
  "product.launchTogetherGrowTogether": "Launch together. Grow together.",
  "product.exploreOnChainIntro":
    "Explore tokens launched by the OURS factory using live on-chain market data.",
  "product.launchTokensReadFailed":
    "Launchpad tokens are temporarily unavailable.",
  "product.dashboardReadFailed":
    "Launchpad statistics are temporarily unavailable.",
  "product.unpricedPairs": "unpriced pairs",
  "product.imageUploadFailed": "Image upload failed.",
  "product.uploadingImage": "Uploading image…",
  "product.unsupportedImageType": "Use a JPEG, PNG, GIF, or BMP image.",
  "product.imageTooLarge": "The image must be 5 MB or smaller.",
  "product.imageUploaded": "Image uploaded. Continue in your wallet.",
  "product.changeImage": "Change image",
  "product.localImageSelected":
    "Local preview selected; it has not been uploaded yet.",
  "product.checkingLocalImage": "Checking the selected image…",
  "product.localImageInvalid": "The selected file cannot be displayed.",
  "product.checkingImageUrl": "Checking whether this image can be displayed…",
  "product.imageUrlValid": "Image loaded successfully.",
  "product.imageUrlInvalid": "This image URL cannot be displayed.",
  "product.imageRequired": "Choose a token image.",
  "product.uploadAndLaunch": "Upload & launch",
  "product.retry": "Retry",
  "product.noLaunchTokens": "No launched tokens found yet.",
  "product.curve": "Bonding curve",
  "product.bondingProgress": "Bonding progress",
  "product.createdAt": "Created",
  "product.graduatedAt": "Graduated",
  "product.next": "Next",
  "product.pagination": "Token list pagination",
  "product.previous": "Previous",
  "product.quoteReserve": "Quote reserve",
  "product.readyToGraduate": "Ready to graduate",
  "product.terminated": "Terminated",
  "product.invalidTokenAddress": "The token address in this link is invalid.",
  "product.launchTokenReadFailed":
    "Unable to read this launch token from the factory.",
  "product.noDescription": "No project description was provided at launch.",
  "product.snipeTax": "Current launch tax",
  "product.insufficientBalance": "Insufficient wallet balance for this trade.",
  "product.curveTradingUnavailable":
    "Bonding-curve trading is no longer available for this token.",
  "product.tradeConfirmed": "Trade confirmed on-chain.",
  "product.tradeVenue": "Trading venue",
  "product.uniswapV4": "Uniswap v4",
  "product.fetchingQuote": "Fetching quote…",
  "product.uniswapV4TradingUnavailable":
    "This token's graduated Uniswap v4 pool is currently unavailable.",
  "product.tradeApprovalNotice":
    "ERC-20 trades may require an approval transaction before the trade is submitted. Minimum received uses 1% slippage protection.",
  "product.tradeHistoryPending": "Trade indexer pending",
  "product.holderDataPending": "Holder indexer pending",
  "product.logoUrl": "Logo URL",
  "product.pairTokenApproved": "Approved by Factory",
  "product.factoryApprovalRequired": "Factory approval required",
  "product.registryApprovalRequired": "Revenue Registry approval required",
  "product.pairTokenEconomicsInvalid":
    "Factory pricing is incomplete or does not match the token decimals",
  "product.invalidAssetAddress": "Enter a valid contract address.",
  "product.verifyingAsset": "Verifying…",
  "product.assetValidationFailed":
    "Unable to verify this ERC-20 contract on Robinhood Chain.",
  "product.assetVerifiedAndAdded":
    "Verified by Factory and Registry · ready in the LP asset list",
  "product.completeTokenIdentity": "Enter the token name and ticker.",
  "product.launchConfigurationLoading":
    "Loading the launch Factory configuration…",
  "product.launchUnavailable":
    "Token launch is unavailable in the current Factory configuration.",
  "product.launchPermissionDenied":
    "Public launch is disabled and this wallet is not on the Factory allowlist.",
  "product.launchAssetsLoading": "Loading the available LP assets…",
  "product.dividendAssetsLoading": "Loading convertible dividend assets…",
  "product.dividendAssetsFallback":
    "The convertible asset list could not be loaded. Using the pair token {{symbol}} by default.",
  "product.selectDividendAssetBeforeLaunch":
    "Select a dividend asset in Advanced settings, or choose a scenario without dividends.",
  "product.selectAllocationScenario":
    "Select a revenue allocation scenario to configure the split.",
  "product.selectRevenueScenarioBeforeLaunch":
    "Select a revenue allocation scenario in Advanced settings.",
  "product.invalidMinimumHolding":
    "Enter a valid minimum holding in Advanced settings.",
  "product.launchFactoryReadFailed":
    "Unable to read the launch Factory configuration.",
  "product.pairTokenReadFailed":
    "Unable to read the Factory's approved assets. Try again later.",
  "product.launchConfirmed": "Token launch confirmed on-chain.",
  "product.launchIndexing":
    "Launch confirmed on-chain. Market data is syncing.",
  "product.onChainDataPending": "On-chain data source pending",
  "product.okxMarketData":
    "OURS launchpad candles · continuous curve and DEX market",
  "product.chartLoading": "Loading TradingView chart…",
  "product.chartIndexing":
    "Trade candles are syncing and will appear when data is available.",
  "product.chartNoTrades":
    "No trades yet. Candles will appear after the first trade.",
  "product.chartLoadError":
    "The chart is temporarily unavailable. Try again later.",
  "product.chartAriaLabel": "{{symbol}} TradingView candlestick chart",
  "product.chartLive": "Live",
  "product.chartConnecting": "Connecting",
  "product.chartCached": "Cached market",
  "product.chartDisconnected": "Disconnected",
  "product.activityReadFailed": "Unable to read recent trades.",
  "product.holdersReadFailed": "Unable to read token holders.",
  "product.noRecentTrades": "No on-chain trades yet.",
  "product.noHolders": "No token holders yet.",
  "product.supplyShare": "Supply share",
  "product.globalCap": "Global cap",
  "product.minimumHoldingProjectTokens": "Minimum holding · project tokens",
  "product.selectAssetPreview": "Select asset · preview",
  "product.selfRetained": "Self-retained",
  "product.platformTokenOnChainIntro":
    "Live ERC-20 supply and wallet balances read directly from the configured Robinhood Chain contract.",
  "product.platformTokenReadFailed":
    "Unable to read the platform token contract. Check the RPC connection and configuration.",
  "product.copyAddress": "Copy address",
  "product.contractAddressCopied": "Contract address copied.",
  "product.viewOnRobinhoodExplorer": "View on Robinhood Chain Explorer",
  "product.totalSupply": "Total supply",
  "product.circulatingSupply": "Circulating supply",
  "product.zeroAndDeadAddresses": "Zero + dead addresses",
  "product.yourTokenBalance": "Your token balance",
  "product.onChainTokenDetails": "On-chain token details",
  "product.tokenName": "Token name",
  "product.tokenSymbol": "Token symbol",
  "product.tokenDecimals": "Decimals",
  "product.latestBlock": "Latest block read",
  "product.liveContractData": "Live contract data",
  "product.platformTokenDataSourceNotice":
    "Name, symbol, decimals, supply, burn balances and connected-wallet balances are refreshed from the RPC every 30 seconds.",
  "product.marketDataUnavailable":
    "No verified market-price source is configured for this token, so price, market cap, volume and fiat portfolio values are intentionally not estimated.",
  "product.marketDataUnavailableShort": "Verified price source unavailable",
  "product.portfolioIndexerUnavailable": "Portfolio indexer unavailable",
  "product.buybackDataUnavailable": "Buyback data unavailable",
  "product.buybackContractNotConfigured":
    "A buyback executor or vault contract has not been configured. No transaction can be submitted and no receipt history is shown.",
  "product.platformBuybackTitle": "Platform token buyback and burn",
  "product.platformBuybackDescription":
    "Eligible trading fees are split {{projectPercent}}% to projects and {{platformPercent}}% to the platform. Of the platform share, {{buybackAndBurnPercent}}% funds buyback and burn, {{liquidityPercent}}% liquidity, {{ecosystemPercent}}% ecosystem growth, and {{operationsAndSecurityPercent}}% operations and security. The strategy buys OURS through Uniswap v4 and atomically burns it in the same transaction.",
  "product.metaDefaultTitle":
    "OURS.MEME — Community-owned Meme Launchpad and Markets",
  "product.metaDefaultDescription":
    "Launch and trade Meme Tokens on Robinhood Chain while building open, transparent onchain markets.",
  "product.metaHomeTitle":
    "OURS.MEME — Community-owned Meme Launchpad and Markets",
  "product.metaHomeDescription":
    "Launch and trade Meme Tokens on Robinhood Chain. Eligible trading fees are split {{projectPercent}}% to projects and {{platformPercent}}% to the platform.",
  "product.metaFundraisingTitle": "OURS Fundraising | OURS.MEME",
  "product.metaFundraisingDescription":
    "View OURS fundraising progress and subscription details. {{marketLiquidityPercent}}% of proceeds support market liquidity and Token market building; {{productAndOperationsPercent}}% supports product development and operations.",
  "product.metaBuybackTitle": "OURS Buyback and Burn | OURS.MEME",
  "product.metaBuybackDescription":
    "View OURS platform token buyback and burn status. {{buybackAndBurnPercent}}% of the platform's fee share funds buyback and burn.",
  "product.metaInfrastructureTitle": "Trading Infrastructure | OURS.MEME",
  "product.metaInfrastructureDescription":
    "Explore OURS.MEME trading infrastructure, route execution, and onchain fee settlement capabilities.",
  "product.platformBuybackReadFailed":
    "Unable to read the platform buyback strategy",
  "product.platformBuybackVersion": "Strategy version",
  "product.platformBuybackReceiver": "Active version receiver",
  "product.platformBuybackStrategy": "Buyback strategy",
  "product.platformBuybackUsdLimit": "USD protection enforced on-chain",
  "product.platformBuybackUsdCap": "Per-execution USD cap",
  "product.platformBuybackExecutionAsset": "Execution input asset",
  "product.platformBuybackQuoteSelected": "Selected by quote",
  "product.platformBuybackExecutionAssetDescription":
    "Budget and limits are checked against the quoted assetIn",
  "product.platformBuybackPendingCollection": "Pending buyback collection",
  "product.platformBuybackPendingCollectionDescription":
    "Treasury budget plus the projected allocation from pending FeePool income",
  "product.platformBuybackCollectionAsset": "Collection asset",
  "product.platformBuybackFeePoolPending": "Pending in FeePool",
  "product.platformBuybackTreasuryBudget": "Treasury budget to collect",
  "product.platformBuybackStrategyBudget": "Strategy budget available",
  "product.platformBuybackStatus": "Strategy status",
  "product.platformBuybackCollect": "Collect buyback budget",
  "product.platformBuybackNothingToCollect": "Nothing to collect",
  "product.platformBuybackCollectFirst": "Collect budget first",
  "product.platformBuybackCollectionDescription":
    "Collection does not require Owner or Operator access. One atomic transaction moves FeePool income into Treasury, then lets the buyback strategy claim its budget; either failure reverts everything.",
  "product.platformBuybackCollectionRequired": "Collection required",
  "product.platformBuybackCollectionRequiredDescription":
    "Buyback budget remains in FeePool or Treasury. Collect it before requesting a buyback quote.",
  "product.platformBuybackCollectionConfirmed":
    "Buyback budget collection confirmed",
  "product.platformBuybackCollectionConfirmedDescription":
    "The buyback strategy received {{amount}} {{symbol}}. On-chain data is refreshing.",
  "product.platformBuybackCollectionFailed": "Buyback budget collection failed",
  "product.platformBuybackExecute": "Execute OURS buyback",
  "product.platformBuybackConnectDescription":
    "Connect and sign in with an authorized platform-strategy wallet to request a signed quote and execute a buyback.",
  "product.platformBuybackNoPermissionDescription":
    "This wallet is not an Owner or Operator of the PLATFORM_V1 buyback strategy and cannot execute buybacks. It can still trigger permissionless budget collection.",
  "product.platformBuybackPaused": "Strategy paused",
  "product.platformBuybackPausedDescription":
    "The buyback strategy or its treasury allocation is paused. Execution will resume after governance unpauses it.",
  "product.platformBuybackReadyDescription":
    "Execution permission is ready. After wallet confirmation, the app requests a short-lived quote. The quote selects the input asset, and the app verifies that asset's budget, price, pool, and limit before fully simulating the buyback and burn.",
  "product.platformBuybackConfirmed": "Platform buyback confirmed",
  "product.platformBuybackConfirmedDescription":
    "Bought and burned {{amount}} {{symbol}}. On-chain data is refreshing.",
  "product.platformBuybackFailed": "Platform buyback failed",
  "product.invalidRecipientAddress": "Enter a valid recipient address.",
  "product.invalidTransferAmount":
    "Enter a positive amount no greater than your token balance.",
  "product.tokenTransferFailed": "Token transfer failed",
  "product.vestingContractNotConfigured":
    "A vesting contract has not been configured.",
} as const;
